
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.224.576a1.2 1.2 0 01.401 1.649l-8.817 14.48a3.695 3.695 0 01-1.088 1.15 3.17 3.17 0 01-1.493.534 3.088 3.088 0 01-1.562-.275 3.485 3.485 0 01-1.244-.978L.87 11.53a1.2 1.2 0 011.863-1.513l4.552 5.606c.125.154.26.253.384.31.122.056.24.075.351.065a.774.774 0 00.364-.135c.13-.087.261-.22.375-.407L17.575.976a1.2 1.2 0 011.65-.4z","fill":"#F2994A"}})])
          )
        }
      }
    